import {Button, Modal} from "antd";
import parse from "html-react-parser";
import React from "react";
import congratsModalConfetti from "../../../assets/images/confetti-modal.png";
import FirebaseService from "../../../core/services/firebase.service";
import "./CongratsModal.scss";

interface IProps {
  winnerPrize?: string;
  callbackGoToBip: () => void;
  callbackOtherService: () => void;
}

const CongratsModal = (props: IProps) => {

  return (
    <Modal
      className="congrats-modal"
      maskStyle={{backdropFilter: "blur(4px)"}}
      visible={!!props.winnerPrize}
      centered
      closable={false}
      footer={false}
    >
      <img
        className="congrats-modal-confetti"
        src={congratsModalConfetti}
        alt="confetti"
      />
      
      <div className="body">


        <div className="content">
          <p className="title">
            {parse(FirebaseService.getValue(FirebaseService.wheel_success_title))}
            &nbsp;
            {props.winnerPrize}
            &nbsp;
            {parse(FirebaseService.getValue(FirebaseService.wheel_success_title2))}
          </p>
          <p className="description">
            {parse(FirebaseService.getValue(FirebaseService.wheel_success_description))}
          </p>

          <div className="button-wrapper">
            <Button
              className="button button-blue"
              onClick={props.callbackGoToBip}
            >
              {parse(FirebaseService.getValue(FirebaseService.wheel_success_button1))}
            </Button>
          </div>
        </div>
      </div>

    </Modal>
  );
}

export default CongratsModal;
